import { CreateActivityBody, ManagedActivity } from '@seiri/shared/common'

/**
 * What the add and edit activity dialogs edit. It is already a valid `CreateActivityBody` - the colour
 * select holds the hex code, not the palette entry - so the dialogs validate against the HTTP schema
 * and send the model unchanged (rule 3 in docs/validation.md).
 */
export type ActivityFormModel = CreateActivityBody

export const emptyActivityFormModel = (): ActivityFormModel => ({
  name: '',
  color: '',
  placeIds: [],
  employeeIds: [],
  enableIndividualEvents: false,
  enableReservations: true, // reservations stay on for every activity; the dialogs do not offer the toggle
})

export const toActivityFormModel = (activity: ManagedActivity): ActivityFormModel => ({
  name: activity.name,
  color: activity.color,
  placeIds: activity.compatiblePlaces.map((place) => place.id),
  employeeIds: activity.assignedEmployees.map((employee) => employee.id),
  enableIndividualEvents: activity.enableIndividualEvents,
  enableReservations: activity.enableReservations,
})
